import React, {
  Dispatch,
  SetStateAction,
  useContext,
} from 'react';
import classNames from 'classnames';

import {
  Fieldset,
  Toggle,
  DateField,
  ToggleGroup,
} from '@ktag/styleguide/dist/react';
import {
  FormFieldEmail,
  FormFieldAHVNumber,
  useAppFormContext,
  AddressInfo,
  FormConfigStore,
  AppFormField,
  FormUtils,
  DeliveryInfo,
  Validators,
} from 'ewp-common';

import formDataStore from 'stores/formDataStore';

interface Props {
  id?: string;
  className?: string;
  additionalClassNames?: string;
  setAddress?: (val: any) => void;
  setRoute?: Dispatch<SetStateAction<number>>,
  cancel?: () => void
}

const PersonalInfo = (props: Props) => {
  const {
    id,
    className,
    additionalClassNames,
  } = props;

  const {
    state: formConfigState,
  } = useContext(FormConfigStore.FormConfigContext);

  const {
    state: formDataState,
  } = useContext(formDataStore.FormDataContext);

  const configs = formConfigState?.data?.labelsMap;
  const { values } = useAppFormContext();

  let showAhvNumber = false;
  if(process.env.REACT_APP_SHOW_AHV_NUMBER_FIELD == "1"){
    showAhvNumber = true;
  }

  return (
    <div id={id} className={classNames(className, additionalClassNames)}>
      <div className="mt-4">
        <h2>{configs.h2Personalien.labelDisplayName}</h2>
        <Fieldset>
          <ToggleGroup
            name={FormUtils.getFieldName(configs.fieldAnrede)}
            label={configs.fieldAnrede.labelDisplayName}
            required={configs.fieldAnrede.mandatory === 'true'}
            infoText={configs.fieldAnrede.labelDescription}
            horizontal
          >
            <Toggle type="radio" value="Herr" label="Herr" />
            <Toggle type="radio" value="Frau" label="Frau" />
          </ToggleGroup>
          <AppFormField formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY} config={configs.fieldName} autocomplete="family-name" />
          <AppFormField formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY} config={configs.fieldFirstname} autocomplete="given-name" />
          {configs?.fieldAhvNumber && showAhvNumber &&
          <FormFieldAHVNumber
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            fieldConfig={configs?.fieldAhvNumber}
            initValue={formDataState.personal.fieldAhvNumber}
          />}
          <DateField
            label={configs.fieldDob.labelDisplayName}
            name={FormUtils.getFieldName(configs.fieldDob)}
            placeholder={configs.fieldDob.labelDescription}
            infoText={configs.fieldDob.labelDescription}
            required
            validate={(value) => Validators.pastDateValidator(value,configs)}
          />
          <AddressInfo
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            fieldsConfig={configs}
            value={values?.personal}
          />
          <AppFormField
            config={configs.fieldPhone}
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            type="tel"
            prefillwith="+41 "
          />
          <FormFieldEmail
            fieldConfig={configs.fieldEmail}
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
          />
          <DeliveryInfo formConfigs={configs} />
        </Fieldset>
      </div>
    </div>
  );
};

PersonalInfo.defaultProps = {
  id: '',
  className: 'personalInfo',
  additionalClassNames: '',
};

export default PersonalInfo;
